import React, { useState, useEffect,useContext } from 'react';
import { DataContext } from '../context/DataProvider';
const LawType = ({ changeTypeFun,type }) => {
  // const [TypeList, setTypeList] = useState([]);
  const {TypeList, setTypeList}=useContext(DataContext)
  const FetLawType = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Get?id=3`)
      .then((res) => res.json())
      .then((data) => setTypeList(data));
  };
  useEffect(() => {
    FetLawType();
  }, []);
// console.log("@@@@@",TypeList) 
  return (
    <>
      <select
        onChange={changeTypeFun}
        className="border w-[100%] ml-5 border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
        defaultValue={type}
      >
        <option value="null"></option>
        {TypeList.map((item) => {
          return item.id == 8 && type!==null ? (
            <option value={item.id} selected>
              {item.item}
            </option>
          ) : (
            <option value={item.id}>{item.item}</option>
          );
        })}
      </select>
    </>
  );
};

export default LawType;
